export interface OperatingHoursDay {
  IsOpen: boolean;
  OpenTime: string;  // "HH:MM" in UTC0 (e.g. "09:00")
  CloseTime: string; // "HH:MM" in UTC0 (e.g. "19:00")
}

export interface OperatingHoursSettings {
  Monday?: OperatingHoursDay;
  Tuesday?: OperatingHoursDay;
  Wednesday?: OperatingHoursDay;
  Thursday?: OperatingHoursDay;
  Friday?: OperatingHoursDay;
  Saturday?: OperatingHoursDay;
  Sunday?: OperatingHoursDay;
}

export interface OrderLimitsSettings {
  MinOrderTotal: number | null;
  MaxOrderTotal: number | null;
}

export interface LocationCheckSettings {
  Enabled: boolean;
  RadiusInMeters: number;
  radiusInMeters?: number; // Backwards compatibility
}

export interface TableOrderSettings {
  Enabled: boolean;
  PaymentRequired: boolean;
}

export interface PickupOrderSettings {
  Enabled: boolean;
  PaymentRequired: boolean;
}

export class QRMenuSettings {
  TableOrder: TableOrderSettings;
  PickupOrder: PickupOrderSettings;
  LocationCheck: LocationCheckSettings;
  TableCall: boolean;
  PaymentRequired?: boolean;
  OperatingHours?: OperatingHoursSettings;
  OrderLimits?: OrderLimitsSettings;

  constructor(data?: Partial<QRMenuSettings> | any) {
    this.PaymentRequired = data?.PaymentRequired ?? data?.paymentRequired ?? false;

    const tableOrder = data?.TableOrder ?? data?.tableOrder;
    this.TableOrder = {
      Enabled: tableOrder?.Enabled ?? tableOrder?.enabled ?? (typeof tableOrder === 'boolean' ? tableOrder : true),
      PaymentRequired: tableOrder?.PaymentRequired ?? tableOrder?.paymentRequired ?? data?.TableOrderPaymentRequired ?? this.PaymentRequired ?? false,
    };

    const pickupOrder = data?.PickupOrder ?? data?.pickupOrder;
    this.PickupOrder = {
      Enabled: pickupOrder?.Enabled ?? pickupOrder?.enabled ?? (typeof pickupOrder === 'boolean' ? pickupOrder : false),
      PaymentRequired: pickupOrder?.PaymentRequired ?? pickupOrder?.paymentRequired ?? data?.PickupOrderPaymentRequired ?? false,
    };

    const loc = data?.LocationCheck ?? data?.locationCheck;
    const radius = loc?.RadiusInMeters ?? loc?.radiusInMeters ?? data?.RadiusInMeters ?? data?.radiusInMeters ?? 100;
    this.LocationCheck = {
      Enabled: loc?.Enabled ?? loc?.enabled ?? (typeof loc === 'boolean' ? loc : false),
      RadiusInMeters: radius,
      radiusInMeters: radius,
    };

    const tableCall = data?.TableCall ?? data?.tableCall;
    this.TableCall =
      typeof tableCall === 'boolean'
        ? tableCall
        : (tableCall?.Enabled ?? tableCall?.enabled ?? (tableCall === 'true' || tableCall === 1 || false));

    const opHours = data?.OperatingHours ?? data?.operatingHours;
    if (opHours) {
      this.OperatingHours = {
        Monday: (opHours.Monday ?? opHours.monday) ? { ...(opHours.Monday ?? opHours.monday) } : undefined,
        Tuesday: (opHours.Tuesday ?? opHours.tuesday) ? { ...(opHours.Tuesday ?? opHours.tuesday) } : undefined,
        Wednesday: (opHours.Wednesday ?? opHours.wednesday) ? { ...(opHours.Wednesday ?? opHours.wednesday) } : undefined,
        Thursday: (opHours.Thursday ?? opHours.thursday) ? { ...(opHours.Thursday ?? opHours.thursday) } : undefined,
        Friday: (opHours.Friday ?? opHours.friday) ? { ...(opHours.Friday ?? opHours.friday) } : undefined,
        Saturday: (opHours.Saturday ?? opHours.saturday) ? { ...(opHours.Saturday ?? opHours.saturday) } : undefined,
        Sunday: (opHours.Sunday ?? opHours.sunday) ? { ...(opHours.Sunday ?? opHours.sunday) } : undefined,
      };
    }

    const limits = data?.OrderLimits ?? data?.orderLimits;
    if (limits) {
      const minVal = limits.MinOrderTotal ?? limits.minOrderTotal;
      const maxVal = limits.MaxOrderTotal ?? limits.maxOrderTotal;
      this.OrderLimits = {
        MinOrderTotal: typeof minVal === 'number' ? minVal : null,
        MaxOrderTotal: typeof maxVal === 'number' ? maxVal : null,
      };
    }
  }
}
